import React from "react";
import { Typography } from "@mui/material";
import { formatUserRole } from "../../modules/Users";

function UserChangeDescription({ item, action, reset, resetAction }) {
    const getDescription = () => {
        const user = item.data.userChange;
        const updates = item.data.newInfo
            ? item.data.newInfo[0]
            : `${user.firstname} ${user.lastname}`;

        switch (action) {
            case "CREATE":
                return `${item.userName} has created a new ${formatUserRole(user.role).toLowerCase()}: ${updates}`;
            case "DELETE":
                return `${item.userName} has deleted the ${formatUserRole(user.role).toLowerCase()}: ${updates}`;
            case "UPDATE":
                if (reset === "RESET" && resetAction === "RESET") {
                    return user.id
                        ? `${item.userName} has sent a password reset to ${formatUserRole(user.role).toLowerCase()} ${updates}`
                        : `${item.userName} has sent a password reset`;
                }
                if (reset === "RESET" && resetAction === "SET-TEMP-PWD") {
                    return user.id
                        ? `${item.userName} has sent a temporary password to ${formatUserRole(user.role).toLowerCase()} ${updates}`
                        : `${item.userName} has sent a temporary password`;
                }
                const {
                    active = "No Change",
                    firstname = "No Change",
                    lastname = "No Change",
                    emailaddress = "No Change",
                    mobilephone = "No Change",
                    role = "No Change",
                    contactconsent = "No Change",
                    timezone = "No Change",
                    offersMobileServices = "No Change",
                    offersVirtualServices = "No Change",
                    vmlink = "No Change",
                    bio = "No Change",
                    maxTravelTime = "No Change",
                    address = "No Change",
                    services = "No Change",
                    skills = "No Change"
                } = updates;

                let description = `${item.userName} has made updates to the user: ${
                    user.firstname + " " + user.lastname
                }, new user details -> Firstname: ${firstname}, Lastname: ${lastname}, 
                Address: ${address}, Email: ${emailaddress}, Phone number: ${mobilephone}, Role: ${role}, Contact Consent: ${contactconsent}, Active: ${active}`;

                if (user.role !== "CLIENT") {
                    description += `, Timezone: ${timezone}, Available for in-home appointments: ${offersMobileServices}, Max travel time: ${maxTravelTime}, 
            Available for virtual appointments: ${offersVirtualServices}, Personal meeting link: ${vmlink}, Bio: ${bio}, Services: ${services}, Skills: ${skills}`;
                }

                return description;
            default:
                return "";
        }
    };

    return <Typography variant="body2">{getDescription()}</Typography>;
}

export default UserChangeDescription;
